import { prop, Vue } from 'vue-class-component';
import clsx from 'clsx';
import styles from './styles.module.scss';

export enum ButtonTypes {
	'link' = 'link',
	'primary' = 'primary',
}

class ButtonProps {
	type = prop<ButtonTypes>({ default: ButtonTypes.primary });

	inverted = prop<boolean>({ default: false });

	fullWidth = prop<boolean>({ default: false });

	inline = prop<boolean>({ default: false });

	iconFirst = prop<boolean>({ default: true })

	onClick = prop<Function>({ default: () => () => undefined });

	target = prop<string>({ default: undefined });

	href = prop<string>({ default: undefined });

	to = prop<string | object>({ default: undefined });

	disabled = prop<boolean>({ default: false });

	wrapped = prop<boolean>({ default: true });
}

export class Button extends Vue.with(ButtonProps) {
	handleClick(event: Event) {
		if (this.disabled) {
			event.preventDefault();
		} else {
			this.onClick(event);
		}
	}

	handleLinkClick(event: Event, navigate: Function) {
		try {
			if (this.disabled) {
				event.preventDefault();
			} else {
				this.handleClick(event);
				navigate(event);
			}
		} catch (e) {
			console.log(e);
		}
	}

	capitalize(str: string): string {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}

	get classes() {
		return clsx([
			this.$attrs.class,
			styles.button,
			!this.$slots.default && styles.buttonNoText,
			this.$slots.icon && this.iconFirst && styles.buttonIconLeft,
			this.$slots.icon && !this.iconFirst && styles.buttonIconRight,
			this.type && this.type === ButtonTypes.link && styles.buttonLink,
			this.type && this.type === ButtonTypes.primary && styles.buttonPrimary,
			this.inline && styles.buttonInline,
			this.inverted && styles.buttonInverted,
			this.fullWidth && styles.buttonFullWidth,
			this.disabled && styles.buttonDisabled,
			this.wrapped && styles.buttonWrapped,
		]);
	}

	render() {
		const slots = <>
			{ this.$slots.icon && this.iconFirst && this.$slots.icon() }
			{ this.$slots.default && <span>{this.$slots.default()}</span> }
			{ this.$slots.icon && !this.iconFirst && this.$slots.icon() }
		</>;

		const createLink = () => {
			if (this.to) {
				return (
					<router-link custom to={ this.to } v-slots={ {
						default: ({ href, navigate }: { href: string; navigate: (payload: MouseEvent) => void }) => (
							<a href={ href } class={ this.classes } onClick={ e => { this.handleLinkClick(e, navigate); } }>
								{ slots }
							</a>
						),
					} }>
					</router-link>
				);
			}

			return (
				<a href={ this.href } class={ this.classes } target={ this.target } onClick={ this.handleClick }>
					{ slots }
				</a>
			);
		};

		const createButton = () => (
			<button onClick={ this.handleClick } class={ this.classes } disabled={ this.disabled }>
				{ slots }
			</button>
		);

		return (
			(this.to || this.href) ? createLink() : createButton()
		);
	}
}
